import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getGeocode } from '../../../../api/googleMaps/services'
import { getArrivalTime } from '../../../../api/timeTerms/services'
import { getDistance, getFormattedAddress } from '../../../../utils/GoogleMapsUtils'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { GoogleLatLng } from '../components/Map/types'
import { Step2FormProps, Step2FormMapProps } from '../types'

const useStep2FormMapOptions = (form: Step2FormProps['form'], activationObject?: ActivationObject): Step2FormMapProps => {
    // dochazi ke geocode adresy ??
    const [isLoading, setIsLoading] = useState<boolean>(false)
    // predchozi hodnoty GPS - budto z activacniho objektu, nebo z geocoderu pri zmene adresy
    const [prevLatLng, setPrevLatLng] = useState<GoogleLatLng>()
    useEffect(() => {
        if (activationObject?.objectGPSLatitude && activationObject?.objectGPSLongitude)
            setPrevLatLng({
                lat: Number(activationObject.objectGPSLatitude),
                lng: Number(activationObject.objectGPSLongitude),
            })
    }, [activationObject?.objectGPSLongitude, activationObject?.objectGPSLatitude])

    const gps = form.watch('objectGPS')
    const { setValue } = form

    const handleLatLngChanged = useCallback(
        (center: GoogleLatLng, zoomCloser?: boolean) => {
            setZoom(zoomCloser ? 18 : undefined)
            setValue('objectGPS', center)
        },
        [setValue]
    )

    const center: GoogleLatLng | undefined = useMemo(() => {
        return gps && Number(gps.lat) && Number(gps.lng)
            ? {
                  lat: Number(gps.lat),
                  lng: Number(gps.lng),
              }
            : undefined
    }, [gps])

    const [zoom, setZoom] = React.useState<number | undefined>()
    React.useEffect(() => {
        if (activationObject?.objectGPSLatitude && activationObject?.objectGPSLongitude) setZoom(18)
    }, [activationObject?.objectGPSLatitude, activationObject?.objectGPSLongitude])

    const objectZIP = form.watch('objectZIP')
    const objectCity = form.watch('objectCity')
    const objectStreet = form.watch('objectStreet')
    const objectCodeNumber = form.watch('objectCodeNumber')
    const objectGuidanceNumber = form.watch('objectGuidanceNumber')

    const [searchAddress, setSearchAddress] = useState<string>('')
    const hasCodeNumber = objectCodeNumber && objectCodeNumber?.length > 1

    const handleAddressChanged = useCallback(async () => {
        const address = getFormattedAddress(objectZIP, objectCity, objectStreet, objectCodeNumber, objectGuidanceNumber)
        if (address.length > 1 && hasCodeNumber && searchAddress !== address) {
            try {
                setIsLoading(true)
                const coords = await getGeocode(address)
                if (coords) {
                    setPrevLatLng(coords)
                    handleLatLngChanged(coords, true)
                }
            } catch (e) {
            } finally {
                setIsLoading(false)
                setSearchAddress(address)
            }
        }
    }, [
        handleLatLngChanged,
        hasCodeNumber,
        objectCity,
        objectCodeNumber,
        objectGuidanceNumber,
        objectStreet,
        objectZIP,
        searchAddress,
    ])

    React.useEffect(() => {
        async function updateArrivalTime(latitude: number, longitude: number) {
            var arrivalTime = await getArrivalTime(latitude, longitude)
            setValue('guaranteedArrivalTime', arrivalTime?.minute > 0 ? arrivalTime.minute : undefined)
            setValue('arrivalVehicle', arrivalTime?.vehicle)
        }
        if (center) updateArrivalTime(center.lat, center.lng)
    }, [center, setValue])

    return {
        center,
        zoom,
        handleLatLngChanged,
        handleAddressChanged,
        isLoading,
        showWarningForGpsChange: gps && prevLatLng ? getDistance(gps, prevLatLng) > 100 : false,
    }
}

export default useStep2FormMapOptions
